import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core'

@Component({
  selector: 'dmmp-logos-link',
  templateUrl: './logos-link.component.html'
})
export class LogosLinkComponent implements OnInit {

  @Input() module
  @Input() identifier
  @Input() defaultClass
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()

  constructor() {
  }

  ngOnInit(): void {
    if (this.module?.content && this.module?.content > 0) {
      this.module.content.forEach(
        (logo) => {
          logo.showTooltip = false
        }
      )
    }
  }

  openTooltip(logo) {
    this.closeOthersTooltips(logo)
    logo.showTooltip = !logo.showTooltip
  }

  closeOthersTooltips(currentLogo) {
    if (this.module?.content && this.module?.content > 0) {
      this.module.content.forEach(
        (logo) => {
          if (logo.id !== currentLogo.id) {
            logo.showTooltip = false
          }
        }
      )
    }
  }

}
